export default __webpack_public_path__ + "static/media/charansingh.c3613f64.jpg";